import React from 'react';
import {
  Card,
  Dropdown,
  DropdownItem,
  Flex,
  Text,
  ThemeModePreference,
  useThemeMode,
} from '@amzn/storm-ui';
import {
  chromeComponents,
  STORM_UI_THEME_MODE_BROADCAST_CHANNEL_KEY,
  STORM_UI_THEME_MODE_STORAGE_KEY,
} from 'src/constants';
import { useHeaderBundle } from 'src/providers/PantherLocalizationProvider';
import { StyledThemeModeTag as Tag } from '../styles';
import { getTaktAttributes } from 'src/commons/utils/logWithTakt';
import useLogThemeMode from 'src/commons/hooks/useLogThemeMode';

const ThemeModesControl = () => {
  const { themeModePreference, themeMode } = useThemeMode();
  const bundle = useHeaderBundle();

  // TODO: move this hook call to Footer.tsx (next to useLogWeblab) once the Footer's ThemeProvider has theme modes enabled
  useLogThemeMode();

  const updateThemeMode = (value: ThemeModePreference) => {
    localStorage.setItem(STORM_UI_THEME_MODE_STORAGE_KEY, value);

    // Broadcast the theme mode change
    if (typeof BroadcastChannel !== 'undefined') {
      try {
        const channel = new BroadcastChannel(
          STORM_UI_THEME_MODE_BROADCAST_CHANNEL_KEY,
        );
        channel.postMessage(value);
        channel.close();
      } catch (error) {
        console.warn('BroadcastChannel API not supported', error);
      }
    }
  };

  return (
    <Card>
      <Flex direction="column" rowGap="xxsmall">
        <Text weight="bold">
          {bundle.getMessage('theme-modes-control-label')}
          <Tag label="Beta" variant="error" />
        </Text>
        <Dropdown
          data-ccx-e2e-id="theme-modes-control"
          onChange={updateThemeMode}
          selectedValue={themeModePreference}
          mobileFullScreen={true}
          {...getTaktAttributes(
            'aac-theme-modes-control',
            chromeComponents.HEADER,
            { ...(themeModePreference && { themeModePreference, themeMode }) },
          )}
        >
          <DropdownItem value="system">
            {bundle.getMessage('theme-modes-control-system-label')}
          </DropdownItem>
          <DropdownItem value="light">
            {bundle.getMessage('theme-modes-control-light-label')}
          </DropdownItem>
          <DropdownItem value="dark">
            {bundle.getMessage('theme-modes-control-dark-label')}
          </DropdownItem>
        </Dropdown>
      </Flex>
    </Card>
  );
};

export default ThemeModesControl;
